// AmiVoice認証トークン取得サービス
export class AmiVoiceService {
  
  /**
   * AmiVoice認証トークンを取得
   * @returns {Promise<string|null>} 成功時はトークン、失敗時はnull
   */
  static async fetchAuthToken() {
    try {
      const response = await fetch("/api/amivoice_tokens", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        }
      })
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      
      const data = await response.json()
      
      if (data.token) {
        console.log("[AmiVoiceService] トークン取得成功")
        return data.token
      } else {
        console.error("[AmiVoiceService] トークン取得失敗: tokenが空")
        return null
      }
    } catch (error) {
      console.error("[AmiVoiceService] API呼び出しエラー:", error)
      return null
    }
  }
}